import React from 'react';
import { getCurrentUser } from '../user';
import { Status } from './useFetchData';

const { useEffect, useReducer } = React;
const FETCH = 'FETCH';
const RECEIVE_USER = 'RECEIVE_USER';
const FETCH_USER_FAILED = 'FETCH_USER_FAILED';
type State = {
  userId: number | null;
  webStationId: string | null;
  error?: string;
  imageUrl: string | null;
  name?: string;
  status: Status;
};

const initialState: State = {
  userId: null,
  webStationId: null,
  status: 'idle',
  imageUrl: null,
};

type Action =
  | { type: typeof FETCH }
  | { type: typeof RECEIVE_USER; payload: CurrentUserResponse }
  | { type: typeof FETCH_USER_FAILED; error: string };

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case FETCH:
      return { ...state, status: 'loading', error: undefined };
    case RECEIVE_USER: {
      if (action.payload) {
        const {
          payload: {
            user: { userId, stationId: webStationId, name, imageUrl },
          },
        } = action;
        return {
          ...state,
          userId,
          webStationId,
          name,
          imageUrl,
          status: 'success',
        };
      }
      return { ...state, status: 'success' };
    }
    case FETCH_USER_FAILED:
      return {
        ...state,
        error: action.error,
        status: 'error',
      };
    default:
      return state;
  }
};

type CurrentUserResponse = {
  user: {
    imageUrl: string | null;
    name: string;
    networkRoleUserId: number;
    stationId: string;
    userId: number;
  };
};

const useCurrentUser = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const fetchWebStationId = () => {
    dispatch({ type: FETCH });
    getCurrentUser()
      .then((res: CurrentUserResponse) => {
        dispatch({
          type: RECEIVE_USER,
          payload: res,
        });
      })
      .catch((err: string) => {
        dispatch({
          type: FETCH_USER_FAILED,
          error: err,
        });
      });
  };
  useEffect(() => {
    fetchWebStationId();
  }, []);
  return { state, dispatch, fetchWebStationId };
};

export { useCurrentUser };
